import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IMessage, IMessageFrom, IdOptions } from '../interfaces'
import { Logger } from '../chatbot-logger.service'
import { MessageBus } from '../service-bus.service'
import { Subscription } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'chatbot-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class MessageComponent implements OnInit {
  @Output() selectedButton = new EventEmitter<any>();
  @Output() selectedToggle = new EventEmitter<any>();

  @Input() message: IMessage

  isExpanded: boolean = false
  isExpandedButtonTitle: string = 'Zobrazit více'
  loading: boolean = false



  constructor() {

  }

  ngOnInit(): void {

   // Logger.info(`${moment().toISOString()} MSG COMP onInit start`)
   // //console.log(`${moment().toISOString()} MSG COMP onInit start`)
    Logger.info(JSON.stringify(this.message))
    this.message = this.handleIncomingMsg(this.message)
    this.loading = this.message.loading


  }

  handleIncomingMsg(message: IMessage): IMessage {
    let res: IMessage
    res = { ...message }
    if (message && message.from && message.from.id && message.from.id === 'op') {
      //skipping classic chat formatting for op messages, NEW funkce pro LV

      //input = "jak najit http://irozhlas.cz"
      //text = 'jak najit <a href=\"http://irozhlas.cz\" target=\"_blank\">http://irozhlas.cz</a>'
      //  //console.log('3======================================================================DEBUG ngOnInit ')
    //  //console.log(`MSG COMP: Ìnput: ${message.message[0]}`)
      let tempText = this.wrapURLs(message.message[0], true)
    //  //console.log(`MSG COMP: Transformed Output: ${tempText}`)
      res.message[0] = tempText
    } else {
      res = this.checkAndParseHtml(message)
    }

    return res
  }

  ngOnDestroy() {

  }

  /**
   * pro LV chat texty
   * @param text 
   * @param new_window 
   */
  private wrapURLs(text, new_window) {
    //   //console.log('======================================================================DEBUG WRAP URL')
    if (text.match(/<a href/g) && text.match(/target/g)) {
      return text
    } else {
      if (text.match(/http:|https:/g)) {
      //  //console.log(`MSG COMP wrapURLs input1: ${text}`)
        let url_pattern = /(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}\-\x{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?/ig;
        let target = (new_window === true || new_window == null) ? '_blank' : '';

        let res2 = text.replace(url_pattern, function (url) {
          //console.log(`wrapURLs input2: ${url}`)
          let protocol_pattern = /^(?:(?:https?|ftp):\/\/)/i;
          let href = protocol_pattern.test(url) ? url : 'https://' + url;
          let res = '<a href="' + href + '" target="' + target + '">' + url + '</a>';
       //   //console.log(`wrapURLs temp Output: ${res}`)
          return res
        });

       // //console.log(`wrapURLs final Output: ${res2}`)
        return res2

      } else {
        return text
      }

    }
  }
  /**
   * PUVODNI VERZE PRO CHATBOT
   * @param message 
   */
  formatUrl(message: string): any {

    let newMessage = []
    let temp1 = message.split('[<a')
    if (temp1.length > 1) {
      for (let temp2 of temp1) {
        if (temp2.indexOf('href') > -1 && temp2.indexOf(']') > -1) {
          Logger.info(`MSG COMP: Link in the text: ${temp2}`)
          let blank = ` target="_blank">`
          let temp3 = temp2.replace('>', blank).replace(']', '')
          temp3 = '<a' + temp3
          Logger.info(`MSG COMP: Formatted url: ${temp3}`)
          newMessage.push(temp3)
        } else {
          newMessage.push(temp2)
        }
      }

      if (newMessage.length > 0) {
        return newMessage.join(' ')
      } else {
        return message
      }
    } else {
      return message
    }
  }

  checkAndParseHtml(message: IMessage): IMessage {
    let res: IMessage
    res = { ...message }
    if (message.message && message.message[0] && message.message[0].length > 0) {

      if (message.message[0].indexOf('href') > -1 && message.message[0].indexOf('[<a') > -1) {
        res.message[0] = this.formatUrl(message.message[0])

      } else {
        Logger.info('MSG COMP: No url link to re-format in the text1')
      }
    } else {
      Logger.info('MSG COMP: No content in the text1')
    }


    if (message.message2 && Array.isArray(message.message2) && message.message2.length > 0 && message.message2[0] != null && message.message2[0].length > 0) {
      if (message.message2[0].indexOf('href') > -1) {


        res.message2[0] = this.formatUrl(message.message2[0])

      } else {
        Logger.info('MSG COMP: No urllink in the text2')
      }


    } else {
      Logger.info('MSG COMP: No content the text2')
    }
    return res
  }

  expandToggle(): void {
    this.isExpanded = !this.isExpanded
    if (!this.isExpanded) {
      this.isExpandedButtonTitle = 'Zobrazit více'
    } else {
      this.isExpandedButtonTitle = 'Zobrazit méně'
    
      this.selectedToggle.emit("scrollDown")
    }
  }

  shouldDisplayButtons(): boolean {
    if (this.message.shouldDisplayButtons) {
      return true
    } else {
      return false
    }
  }

  shouldDisplayButtonForMsg2(): boolean {
    try {
      if (this.message.message2 && Array.isArray(this.message.message2) && this.message.message2.length > 0 && this.message.message2[0] != null && this.message.message2[0].length > 0) {
        return true
      } else {
        return false
      }
    } catch (err) {
   //   //console.log(`MSG COMP: shouldDisplayButtonForMsg2 err for message: ${JSON.stringify(this.message)}`)
    //  //console.log(`MSG COMP: shouldDisplayButtonForMsg2 err for message: ${JSON.stringify(this.message.message2.length)}`)
      return false
    }
  }

  onSelectButton(event): void {
    Logger.info(`MSG COMP: Button (intent) selected: ${event}`)
    //Emitace udalosti pro send message 
    this.selectedButton.emit(event)
  }

  /*
    parseLinkButton(buttontext) {
      let obj = {
        output: buttontext,
        content: buttontext,
        isLink: true,
        isDisabled: false
      }
      let ix = buttontext.indexOf('|');
      if (ix !== -1) {
        obj.content = buttontext.substring(0, ix);
        obj.output = buttontext.substring(ix + 1);
      } else {
        obj.content = 'Cannot parse';
        obj.output = '(prase)';
      }
      //obj.isLink = true;
      this.buttons.push(obj)
    }
  
    findAll(element, elementname) {
      let stack = [], ii;
      let arr = [];
      stack.push(element);
  
      while (stack.length > 0) {
        element = stack.pop();
        if (element.name === elementname) {
          // Found it!
          arr.unshift(element)
        } else if (element.children && element.children.length) {
          for (ii = 0; ii < element.children.length; ii += 1) {
            stack.push(element.children[ii]);
          }
        }
      }
  
      return arr
    }
  
    removeGarbage(message, garbage) {
      garbage.forEach(elem => {
        message = message.replace(elem, '')
      })
      return message;
    }
    */

}
